import { useTranslation } from 'react-i18next';

// Components
import ItemDetail from '../ItemDetail';
import OrderCard from '../OrderCard';

// Styles
import styles from './index.module.sass';

type Props = {
  totals: Object,
  device: Object,
};

export default function OrderTotals({ totals = {}, device, loading = false }: Props) {
  const {
    modulosDescripcion = '',
    modulosCantidad = '',
    totalAImporte = '',
    totalBImporte = '',
    totalUnidadesAB = '',
    totalAUnidades = '',
    totalBUnidades = '',
    flete = '',
    subtotal = '',
    iva = '',
    saldoActual = '',
    importeAPagar = '',
    coloradoTax = '',
    firma = '',
  } = totals;

  const screenSize = device?.screenSize || 'desktop';

  const { t } = useTranslation('order');

  console.log('shopping');

  return (
    <div className={`${styles.container} ${styles[screenSize]}`}>
      <OrderCard title={t('detailTitle')} open={screenSize === 'phone' ? false : true}>
        <div className={styles.orderDet}>
          <div className={styles.detailContainer}>
            <ItemDetail title={t('description')} text={modulosDescripcion} loading={loading} />
            <ItemDetail title={t('modules')} text={modulosCantidad || 0} loading={loading} />
            <ItemDetail title={t('amountA')} text={`$${totalAImporte || 0}`} loading={loading} />
            <ItemDetail title={t('amountB')} text={`$${totalBImporte || 0}`} loading={loading} />
            <ItemDetail title={t('unitsAB')} text={totalUnidadesAB || 0} loading={loading} />
            <ItemDetail title={t('unitsA')} text={totalAUnidades || 0} loading={loading} />
            <ItemDetail title={t('unitsB')} text={totalBUnidades || 0} loading={loading} />
            <ItemDetail title={t('shipment')} text={`$${flete || 0}`} loading={loading} />
            <ItemDetail
              title={t('deliverWithSignature')}
              text={`$${firma || 0}`}
              loading={loading}
            />
          </div>
        </div>
      </OrderCard>
      <OrderCard title={t('summaryTitle')} open={screenSize === 'phone' ? false : true}>
        <div className={styles.orderDet}>
          <div className={styles.detailContainer}>
            <div className={styles.item}>
              <div className={styles.title}>{t('subtotal')}:</div>
              <div className={styles.number}>{'$' + subtotal || 0}</div>
            </div>
            <div className={styles.item}>
              <div className={styles.title}>{t('taxes')}:</div>
              <div className={styles.number}>{'$' + iva || 0}</div>
            </div>
            {coloradoTax && (
              <div className={styles.item}>
                <div className={styles.title}>{t('coloradoTax')}:</div>
                <div className={styles.number}>{'$' + coloradoTax || 0}</div>
              </div>
            )}
            {saldoActual && (
              <div className={styles.item}>
                <div className={styles.title}>{t('currentBalance')}:</div>
                <div className={styles.number}>${saldoActual || 0}</div>
              </div>
            )}
            <div>
              <hr></hr>
            </div>
          </div>
          <div className={styles.detailContainer}>
            <div className={styles.item}>
              <div className={styles.titleGold}>{t('amountToPay')}:</div>
              <div className={styles.numberGold}>{'$' + importeAPagar || 0}</div>
            </div>
          </div>
        </div>
      </OrderCard>
    </div>
  );
}
